var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("j-dict-select-tag", {
            staticStyle: { width: "170px", "margin-right": "15px" },
            attrs: {
              placeholder: "请选择年级",
              dictCode:
                "school_grade,grade_name,id,0=delete_flag order by sort_order",
              isShowEmpty: false,
            },
            on: {
              select: function ($event) {
                return _vm.$set(_vm.queryParam, "classId", undefined)
              },
            },
            model: {
              value: _vm.queryParam.gradeId,
              callback: function ($$v) {
                _vm.$set(_vm.queryParam, "gradeId", $$v)
              },
              expression: "queryParam.gradeId",
            },
          }),
          _c("j-dict-select-tag", {
            staticStyle: { width: "170px", "margin-right": "15px" },
            attrs: {
              placeholder: "请选择班级",
              dictCode:
                "school_class,name,id,grade_id=" +
                (!_vm.queryParam.gradeId ? -1 : _vm.queryParam.gradeId),
              async: true,
              disabled: !_vm.queryParam.gradeId,
              isShowEmpty: false,
            },
            model: {
              value: _vm.queryParam.classId,
              callback: function ($$v) {
                _vm.$set(_vm.queryParam, "classId", $$v)
              },
              expression: "queryParam.classId",
            },
          }),
          _c("a-input-search", {
            staticStyle: { width: "170px", "margin-left": "15px" },
            attrs: { placeholder: "请输入学生名字" },
            on: { change: _vm.searchName },
            model: {
              value: _vm.queryParam.name,
              callback: function ($$v) {
                _vm.$set(_vm.queryParam, "name", $$v)
              },
              expression: "queryParam.name",
            },
          }),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "15px" },
              attrs: { type: "primary" },
              on: { click: _vm.loadData },
            },
            [_vm._v("查询")]
          ),
        ],
        1
      ),
      _c("TableList", {
        staticStyle: { width: "100%", "margin-top": "10px" },
        attrs: {
          columns: _vm.columns,
          tableData: _vm.tableData,
          loading: _vm.loading,
          scroll: {},
          pagination: _vm.pagination,
        },
        on: { change: _vm.handleTableChange },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function ({ record }) {
              return undefined
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }